import * as React from 'react'
import PropTypes from 'prop-types'
import makeStyles from '@material-ui/core/styles/makeStyles'
import ArticleCard from 'containers/ArticleCard'
import Container from 'components/Container'
import Section from 'components/Section'
import Typography from 'components/Typography'
import { useGlobal } from 'api'

const BREAKPOINT_KEY_DOWN = 'xs'
const BREAKPOINT_KEY_UP = 'sm'

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: -1,
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  main: {
    [theme.breakpoints.up(BREAKPOINT_KEY_UP)]: {
      display: 'grid',
      gridTemplateColumns: '1fr 3fr',
    },
  },
  header: {
    padding: 'var(--coa-section-spacing) var(--coa-container-spacing) 0',
    [theme.breakpoints.up(BREAKPOINT_KEY_UP)]: {
      paddingRight: 0,
    },
  },
  heading: {
    [theme.breakpoints.up(BREAKPOINT_KEY_UP)]: theme.typography.h4,
  },
  listContainer: {
    overflow: 'hidden',
  },
  list: {
    [theme.breakpoints.down(BREAKPOINT_KEY_DOWN)]: {
      ...theme.mixins.hideScrollbars,
      scrollSnapType: 'x mandatory',
      overflowX: 'scroll',
      display: 'flex',
    },
    [theme.breakpoints.up(BREAKPOINT_KEY_UP)]: {
      overflow: 'hidden',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
  listItem: {
    display: 'flex',
    padding: 'var(--coa-section-spacing) var(--coa-container-spacing)',
    [theme.breakpoints.down(BREAKPOINT_KEY_DOWN)]: {
      scrollSnapAlign: 'start',
      flexShrink: 0,
      width: 'calc(100% - 80px)',
    },
    [theme.breakpoints.up(BREAKPOINT_KEY_UP)]: {
      margin: '0 -1px -1px 0',
      borderRight: `1px solid ${theme.palette.divider}`,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
}))

function ArticleGroup(props) {
  const { heading, items } = props

  const { market } = useGlobal()
  const classes = useStyles(props)

  return (
    <Section className={classes.root}>
      <Container className={classes.main} maxWidth="xl" disableGutters>
        <div className={classes.header}>
          <Typography className={classes.heading} component="h1" variant="h5">
            {heading}
          </Typography>
        </div>

        <div className={classes.list}>
          {items?.map((item, idx) => (
            <div key={idx} className={classes.listItem}>
              {item.heading &&
                item.excerpt &&
                (item.markets === '' || item.markets?.includes(market.code)) && (
                  <ArticleCard
                    id={item.id}
                    article={item.article}
                    disableLineClamp={item.disableLineClamp}
                    excerpt={item.excerpt}
                    heading={item.heading}
                    mediaPlacement={item.mediaPlacement === '' ? 'start' : item.mediaPlacement}
                    mediaSrc={item.mediaSrc}
                    subheading={item.subheading}
                    url={item.showReadMore ? item.url : null}
                  />
                )}
            </div>
          ))}
        </div>
      </Container>
    </Section>
  )
}

ArticleGroup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired, // Let `ArticleCard` handle prop validation.
  heading: PropTypes.string,
}

export default ArticleGroup
